import type { DictsysInflectionSchemeContent } from ".";

// ADJECTIVES
export const DictsysEnglishComparisons = ["positive", "comparative", "superlative"] as const;
export type DictsysEnglishComparison = (typeof DictsysEnglishComparisons)[number];

export type DictsysInflectionSchemeEnglishAdjectiveComparisons = Record<
  DictsysEnglishComparison,
  DictsysInflectionSchemeContent[]
>;
